import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import BlockView from "./BlockView";
import { hideModal, showModal } from "../../../actions/modals";
import modalTypes from "../../../constants/modalTypes";

const mapStateToProps = (state, ownProps) => {
    const ceremonyId = parseInt(ownProps.match.params.ceremonyID);
    const ceremony = state.entities.ceremonies.byId[ceremonyId];
    const ceremonyMainImage =
        state.entities.photos.byId[ceremony.item.mainImageId];

    let room = state.entities.rooms.byId?.[ceremony?.item?.room] ?? null;

    return {
        alternativePlaceholderImage: ceremonyMainImage,
        ceremonyId: ceremonyId,
        room: room,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        dispatch,
        showBlockPhotoUploadModal: (blockId) => {
            dispatch(hideModal());
            dispatch(
                showModal({
                    type: modalTypes.BLOCK_PHOTO_UPLOAD,
                    props: {
                        ceremonyId: props.block.ceremonyId,
                        blockId: parseInt(blockId),
                    },
                })
            );
        },
        showBlockPhotoProcessingFailureModal: (blockId) => {
            dispatch(
                showModal({
                    type: modalTypes.BLOCK_PHOTO_PROCESSING_FAILURE,
                    props: {
                        ceremonyId: props.block.ceremonyId,
                        blockId: parseInt(blockId),
                    },
                })
            );
        },
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(BlockView)
);
